export default {
    loading: 'advertPositionDataCurve:loading',
    search: 'advertPositionDataCurve:search',
    statisticList: 'advertPositionDataCurve:list',
    agents: 'advertPositionDataCurve:agents',
    areas: 'advertPositionDataCurve:areas',
    statisticTotal: 'advertPositionDataCurve:total',
    url: 'advertPositionDataCurve:url',

}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/advertPositionDataCurve/constant.js